// extracted by mini-css-extract-plugin
export var band = "band-module--band--u56FL";
export var country = "band-module--country--meKlB";
export var details = "band-module--details--+HSho";
export var footer = "band-module--footer--0z-Gl";
export var icon = "band-module--icon--Yn2YE";
export var img = "band-module--img--WY6fe";
export var imgContainer = "band-module--img-container--NVOgR";
export var info = "band-module--info--icdGl";
export var link = "band-module--link--OwvOb";